<script setup lang="ts">
  import { provide, ref, watch } from 'vue'
  import AppButton from '@/components/app-button.vue'
  import AppSwitch from '@/components/app-switch.vue'

  const showSaleReceipt = ref(true)
  const showCustomerAddress = ref(true)
  const hasCustomerAddress = ref(false)

  watch([showSaleReceipt, showCustomerAddress], ([saleValue, addressValue]) => {
    if (!saleValue && !addressValue) {
      showCustomerAddress.value = true
    }
  })

  provide('showCustomerAddress', showCustomerAddress)
  provide('showSaleReceipt', showSaleReceipt)
  provide('hasCustomerAddress', hasCustomerAddress)

  const openPrintDialog = () => window.print()
</script>

<template>
  <div class="relative min-h-screen bg-gray-100 print:bg-white">
    <div class="print-options">
      <div class="space-y-2">
        <template v-if="hasCustomerAddress">
          <div class="switch-group">
            <span :class="showSaleReceipt ? 'text-primary font-semibold' : 'text-gray-500'">
              Nota Jual
            </span>
            <app-switch
              v-model="showSaleReceipt"
              :disabled="!showCustomerAddress" />
          </div>
          <div class="switch-group">
            <span :class="showCustomerAddress ? 'text-primary font-semibold' : 'text-gray-500'">
              Nota Alamat
            </span>
            <app-switch
              v-model="showCustomerAddress"
              :disabled="!showSaleReceipt" />
          </div>
        </template>
      </div>

      <app-button
        class="btn-primary"
        @click="openPrintDialog">
        Cetak Struk
      </app-button>
    </div>

    <div class="preview flex justify-center">
      <router-view />
    </div>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  :deep() {
    @import '@/assets/styles/print-receipt.css';
  }

  .switch-group{
    @apply flex justify-between gap-2 border bg-white rounded p-2 text-sm items-center;
  }
</style>
